import React, { createContext, useContext, useState } from 'react';
import AlertModal from '../components/ui/AlertModal';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    isVisible: false,
    message: '',
    type: 'success',
  });

  const mostrarAlerta = (message, type = 'success') => {
    setAlert({ isVisible: true, message, type });

    setTimeout(() => {
      setAlert((prev) => ({ ...prev, isVisible: false }));
    }, 4000);
  };

  const cerrarAlerta = () => {
    setAlert((prev) => ({ ...prev, isVisible: false }));
  };

  return (
    <AlertContext.Provider value={{ mostrarAlerta }}>
      {children}
      <AlertModal
        isVisible={alert.isVisible}
        type={alert.type}
        message={alert.message}
        onClose={cerrarAlerta}
      />
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
